import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bfb9b1b0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bfb9b1b0&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfb9b1b0')) {
      api.createRecord('bfb9b1b0', component.options)
    } else {
      api.reload('bfb9b1b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bfb9b1b0", function () {
      api.rerender('bfb9b1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/users/index.vue"
export default component.exports